import { messages } from '@qality/common-messages';
import { TestCase, TestCasesCollection } from '@qality/common-model';
import { AsyncService, StorageOfUniqueServices } from '@qality/common-service';
import { LocalStorageUtils } from '@qality/common-utils';

export default {
  updateExpandValue(
    issueKey: string,
    testCase: TestCase,
    value: boolean
  ): void | boolean {
    let properties = LocalStorageUtils.retrieveUserSettings(
      issueKey + '_testCasesProperties'
    );
    properties = properties ? properties : {};
    testCase.issue
      .then((issue) => {
        properties[issue.id] = {
          expanded: value,
        };
        return LocalStorageUtils.storeUserSettings(
          properties,
          issueKey + '_testCasesProperties'
        );
      })
      .catch(() => {
        return false;
      });
  },

  async expandAllTestCases(
    issueKey: string,
    testCases: TestCasesCollection,
    expandedAll: boolean
  ): Promise<void> {
    const properties = {};

    await AsyncService.asyncForEach(testCases.testCases, async (testCase) => {
      try {
        const issue = await testCase.issue;
        properties[issue.id] = {
          expanded: expandedAll,
        };
      } catch (e) {
        StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
          e,
          messages['error.testCase.actions.expandAll']
        );
      }
    });

    LocalStorageUtils.storeUserSettings(
      properties,
      issueKey + '_testCasesProperties'
    );
  },
};
